//NOTE - Library Import
import './App.css';
import React, {Suspense} from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import ReactGA from "react-ga4";
import { analyticsEnabled } from "./includes/analytics";

//NOTE - App Components
import Header from './includes/header';
import Home from './home/home';
import About from './about/about';
import Portfolio from './portfolio/portfolio';
import Pricing from './pricing/pricing';
import Careers from './careers/careers';
import JobDetail from './careers/jobDetail';
import Services from './services/services';
import PMOServices from './pmo/pmo';
import ContactForm from './includes/contact';
import Footer from './includes/footer';
import TermsAndPrivacyPolicy from './terms/terms-and-privacy-policy';
import ErrorPage from './404';
import { ParallaxProvider } from 'react-scroll-parallax';
import ScrollToTop from './includes/scrollToTop';

const App = () => {
  if (analyticsEnabled()) {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  }

    return (
      <ParallaxProvider>
        <Router>
          <Suspense fallback={<div>Loading...</div>}>
          <ScrollToTop />
          <div className="App bg-white10 bg-mainBG bg-100 bg-top bg-repeat-y">
            <Header />
            <div className="-mt-28 pt-28">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/portfolio" element={<Portfolio />} />
                <Route path="/services" element={<Services />} />
                <Route path="/pmo-services" element={<PMOServices />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/careers/:roleId" element={<JobDetail />} />
                <Route path="/terms-and-privacy-policy" element={<TermsAndPrivacyPolicy />} />
                <Route path="*" element={<ErrorPage />} />
              </Routes>
              <ContactForm />
            </div>
            <Footer />
          </div>
          </Suspense>
        </Router>
      </ParallaxProvider>
    );
}

export default App;
